

























































import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator'
import { Address } from 'serverless-firestore'
import { Loader as GMapsLoader } from '@googlemaps/js-api-loader'

import { LocaleService } from '@/services/locale.service'

@Component
export default class AddressEdit extends Vue {
  @Ref() readonly addressAutoComplete!: Vue

  @Prop({ type: String, default: 'default' })
  public layout!: 'default' | 'auto' | 'small'

  public get layoutCols() {
    return this.layout === 'auto' ? undefined : 12
  }

  public layoutMd(ratio: number) {
    return this.layout === 'default' ? ratio : undefined
  }

  @Prop({ type: Object, default: () => new Address() })
  public value!: Address

  public formAddress = new Address()
  public placeAddress!: Address

  public usStates = LocaleService.states('United States')

  private get required() {
    return this.$attrs.hasOwnProperty('required')
  }

  public rules = {
    address: [ this.validateField('Please provide Street Address') ],
    city: [ this.validateField('Please provide City') ],
    state: [ this.validateField('Please provide State') ],
    postalCode: [ this.validateField('Please provide ZIP Code') ]
  }

  public placesService: object | null =  null
  public autocomplete!: google.maps.places.Autocomplete

  private addressComponentFieldMap = {
    'street_number': 'streetNumber',
    'route': 'street',
    'subpremise': 'subpremise',
    'locality': 'city',
    'administrative_area_level_1': 'state',
    'country': 'country',
    'administrative_area_level_2': 'county',
    'postal_code': 'postalCode'
  }
  private formAddressFields = [
    'streetAddress',
    'subpremise',
    'city',
    'state',
    'postalCode',
    'country'
  ]

  public async mounted() {
    await this.loadPlacesApi()
  }

  @Watch('value', { immediate: true, deep: true })
  public valueChange(value: Address) {
    if (value && Address.isAddress(value)) {
      const addressValue = value instanceof Address
        ? value
        : Object.assign(new Address(), value)

      if (addressValue.placeId) {
        this.placeAddress = addressValue
        this.syncForm(addressValue)
      } else {
        this.formAddress = addressValue
      }
    }
  }

  public inputChange() {
    if (this.placeAddress && this.placeAddress.placeId) {
      // see if formAddress matches placeAddress
      if (
        this.placeAddress.streetNumber === this.formAddress.streetNumber
        && this.placeAddress.street === this.formAddress.street
        && this.placeAddress.city === this.formAddress.city
        && this.placeAddress.state === this.formAddress.state
        && this.placeAddress.postalCode === this.formAddress.postalCode
        && this.placeAddress.country === this.formAddress.country
      ) {
        this.placeAddress.subpremise = this.formAddress.subpremise
        return this.emitAddress(this.placeAddress)
      }
    }
    return this.emitAddress(this.formAddress)
  }

  public async loadPlacesApi() {
    const placesLoader = new GMapsLoader({
      apiKey: this.$firebaseConfig.apiKey,
      version: 'quarterly',
      libraries: ['places']
    })
    await placesLoader.load()

    // @ts-ignore
    this.autocomplete = new google.maps.places.Autocomplete(
      this.addressAutoComplete.$refs.input as HTMLInputElement,
      {
        types: ['address'],
        //componentRestrictions: { country: 'us' }
      }
    )

    this.autocomplete.setFields([
      'name',
      'address_component',
      'formatted_address',
      'geometry',
      'place_id'
    ])
    this.autocomplete.addListener(
      'place_changed',
      () => this.setAddressFromPlace()
    )
  }

  private setAddressFromPlace() {

    if (!this.autocomplete) { return }

    const place = this.autocomplete.getPlace()

    if (!place || !place.place_id) { return }

    const address = new Address()
    address.placeId = place.place_id
    address.name = place.name
    address.address = place.formatted_address
    if (place.geometry) {
      address.lat = place.geometry.location.lat().toString()
      address.lng = place.geometry.location.lng().toString()
    }

    if (place.address_components) {
      const map = this.addressComponentFieldMap
      place.address_components.forEach(component => {
        const type = component.types[0]
        if (Object.keys(this.addressComponentFieldMap).includes(type)) {
          const field: string = this.addressComponentFieldMap[type as keyof typeof map]
          if (field) {
            // @ts-ignore
            address[field] = component.long_name
          }
        }
      })
    }

    this.placeAddress = address
    this.syncForm(address)
    this.emitAddress(this.placeAddress)
  }

  private syncForm(address: Address) {
    this.formAddressFields.forEach(field => {
      // @ts-ignore
      this.$set(this.formAddress, field, address[field])
    })
  }

  private validateField(errMessage: string) {
    return (v: string | number) => {
      if (!this.required) { return true }
      if (typeof v === 'string') {
        return !!v ? true : errMessage
      }
      if (v !== null && v !== undefined) { return true }
      return errMessage
    }
  }

  private emitAddress(address: Address) {
    address.id = this.value.id
    this.$emit('input', address)
  }
}
